var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "부담작업 목록",
            columns: _vm.gridColumns,
            data: _vm.grid.data,
            isExcelDown: false,
            isFullScreen: false,
            columnSetting: false,
            hideBottom: true,
            gridHeightAuto: "",
          },
          scopedSlots: _vm._u([
            {
              key: "customHeader",
              fn: function ({ props, col }) {
                return [_c("q-img", { attrs: { src: `${col.src}` } })]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLSELECT", icon: "check" },
                        on: { btnClicked: _vm.select },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }